import React, { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/auth.context';

interface PrivateRouteProps {
  org?: string;
  children: JSX.Element;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({children, org}) => {
  const { isLoggedIn, isLoggedOrg } = useAuth();
  if(!isLoggedIn){
    return <Navigate to="/login" replace />;
  }
  if(!isLoggedOrg(org || "")){
    return <Navigate to="/home" replace />;
  }
  return children;
};

export default PrivateRoute;